import * as Mapping from './mapping';
import * as QA from 'shared/utils/queryAnalysis';


const ColumnType = {
  Master: 'masterId',
  Victim: 'victimId',
};

export async function mergeObjects(excelHeaders, merge, ctx) {
  const columns = await processColumns(excelHeaders, merge, ctx);
  const completeMapping = await Mapping.applyMapping(excelHeaders, merge.mapping, ctx);

  const columnIndexSet = new Set();
  columns.forEach(x => columnIndexSet.add(x.columnData.columnIndex));
  completeMapping.mapping.forEach(y => columnIndexSet.add(y.columnData.columnIndex));
  const columnIndexes = [...columnIndexSet];

  Mapping.mapDataColumnIndexes(columnIndexes, completeMapping.mapping);
  Mapping.mapDataColumnIndexes(columnIndexes, columns);

  const processRow = (row, rowIndex) => {
    const masterRecord = {};
    const recordToMergeIds = [];
    const errors = [];

    columns.forEach(mappedColumn => {
      const { fieldName, rawField: { name } } = mappedColumn.columnData;
      const { error, value } = Mapping.applyMappedColumnToRow(row, rowIndex, mappedColumn);

      error
        ? errors.push(error)
        : fieldName === ColumnType.Master
          ? masterRecord[name] = value
          : recordToMergeIds.push(value);      
    });
    
    completeMapping.mapping.forEach(mappedColumn => {
      const { name } = mappedColumn.columnData.rawField;
      const { error, value } = Mapping.applyMappedColumnToRow(row, rowIndex, mappedColumn);
      error
        ? errors.push(error)
        : masterRecord[name] = value;
    });

    
    const object = { masterRecord, recordToMergeIds };

    return { object, errors };
  }

  return { processRow, columnIndexes, mapping: completeMapping, columns };
}

async function processColumns(excelHeaders, merge, ctx) {
  const { mapping, columnIndexes } = merge;
  const { sfObjectName: objectName } = mapping;

  const columnConversion = {
    [ColumnType.Master]: QA.KnownFields.Id,
    [ColumnType.Victim]: QA.KnownFields.Id,
  };

  return await Mapping.loadColumns(excelHeaders, { columnIndexes, objectName, columnConversion }, ctx);
}